import { createFileRoute, Link } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { getPreviewDecks, initializePreviewData } from '@/lib/previewStorage'
import type { PreviewDeck } from '@/lib/previewStorage'

export const Route = createFileRoute('/preview/decks/')({
  component: PreviewDecksPage,
})

function PreviewDecksPage() {
  const [decks, setDecks] = useState<PreviewDeck[]>([])

  useEffect(() => {
    // Initialize if needed
    if (!sessionStorage.getItem('preview_flashcard_decks')) {
      initializePreviewData()
    }
    setDecks(getPreviewDecks())
  }, [])

  return (
    <div className="min-h-screen bg-black text-white py-4 sm:py-8 px-2 sm:px-4">
      <div className="max-w-6xl mx-auto">
        {/* Preview Banner */}
        <div className="mb-4 bg-terminal-green/20 border-2 border-terminal-green p-3 text-center">
          <p className="text-terminal-green font-mono text-sm font-bold">
            [PREVIEW MODE] • Data stored in browser session • Sign up to save progress
          </p>
        </div>

        {/* Header */}
        <div className="mb-4 sm:mb-8 terminal-border p-4 sm:p-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-sky-blue mb-2 font-mono tracking-wider">
                [FLASHCARD DECKS]
              </h1>
              <p className="text-trail-tan font-mono text-sm sm:text-base">
                Manage your flashcard collections (Preview Mode)
              </p>
            </div>
            <Link
              to="/preview/decks/add"
              className="px-4 sm:px-6 py-2 sm:py-3 bg-terminal-green text-black font-bold font-mono text-sm sm:text-base border-4 border-terminal-green hover:bg-black hover:text-terminal-green transition-all retro-glow"
            >
              + CREATE DECK
            </Link>
          </div>
        </div>

        {/* Decks Grid */}
        {decks.length === 0 ? (
          <div className="terminal-border p-8 text-center">
            <div className="text-sky-blue text-xl font-bold font-mono mb-3">NO DECKS YET</div>
            <p className="text-trail-tan font-mono mb-6">Create your first deck to get started!</p>
            <Link
              to="/preview/decks/add"
              className="inline-block px-6 py-3 bg-terminal-green text-black font-bold font-mono border-4 border-terminal-green hover:bg-black hover:text-terminal-green transition-all"
            >
              CREATE FIRST DECK
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {decks.map((deck) => (
              <div
                key={deck.id}
                className="terminal-border p-4 sm:p-6 bg-black hover:border-terminal-green transition-all cursor-pointer block"
              >
                <h2 className="text-xl font-bold text-terminal-green mb-2 font-mono">{deck.name}</h2>
                {deck.description && (
                  <p className="text-trail-tan text-sm font-mono mb-4 line-clamp-2">
                    {deck.description}
                  </p>
                )}
                <div className="text-sky-blue text-xs font-mono">
                  Created: {new Date(deck.createdAt).toLocaleDateString()}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

